import _ from 'underscore';
import { ProjectionGridBaseColumn } from '@bingads-webui/projection-grid-base-column';

import template from './preview-improve-rsa-column.pug';

export class PreviewImproveRSAColumn extends ProjectionGridBaseColumn {
  constructor({
    deps = {
      adDisplayUrlService: null,
      combineText: null,
    },
    i18n,
    newI18n,
  }) {
    super({
      name: 'PreviewdAd',
      property: 'PreviewdAd',
      title: newI18n.getString(_TL_('Responsive Search ads recommendations')),
      sortable: false,
      bodyClasses: ['suggested-ads-preview-column'],
      colClasses: ['rsa-col-ads-preview'],
    });

    this.deps = deps;
    this.i18n = i18n;
    this.newI18n = newI18n;
  }

  template({ value: { SuggestedAssets } }) {
    const { i18n, newI18n } = this;
    const urlRegex = new RegExp('http:\/\/|https:\/\/|\{param', 'i'); // eslint-disable-line  no-useless-escape
    let destinationUrl = SuggestedAssets.FinalUrl;
    // add http for destinatioUrl that did not have them.
    if (destinationUrl && destinationUrl.search(urlRegex) === -1) {
      destinationUrl = `http://${destinationUrl}`;
    }

    let moreHeadlines;
    if (_.size(SuggestedAssets.Headlines) > 3) {
      moreHeadlines = ` +${i18n.getString('Recommendation_Grid_Todo_More', {
        count: _.size(SuggestedAssets.Headlines) - 3,
      })}`;
    }

    let moreDescriptions;
    if (_.size(SuggestedAssets.Descriptions) > 2) {
      moreDescriptions = ` +${i18n.getString('Recommendation_Grid_Todo_More', {
        count: _.size(SuggestedAssets.Descriptions) - 2,
      })}`;
    }

    const ad = {
      convertedTitle: _.compact([
        SuggestedAssets.Headlines[0].Text,
        SuggestedAssets.Headlines[1].Text,
        SuggestedAssets.Headlines[2].Text]).join(' | '),
      convertedText: this.deps.combineText(
        SuggestedAssets.Descriptions[0].Text,
        SuggestedAssets.Descriptions[1].Text
      ),
      convertedFinalUrl: destinationUrl,
      convertedDisplayUrl: this.deps.adDisplayUrlService.getExpandedTextAdDisplayUrl(
        destinationUrl,
        null,
        SuggestedAssets.Path1,
        SuggestedAssets.Path2
      ),
      title: i18n.getString('Entity_Ads'),
    };

    let numberOfSuggestedHeadline = 0;
    const lastExistingHeadlineIndex = _.findLastIndex(SuggestedAssets.Headlines, { Source: 'AdvExt_Headline' });
    if (lastExistingHeadlineIndex !== -1) {
      numberOfSuggestedHeadline = SuggestedAssets.Headlines.length - lastExistingHeadlineIndex - 1;
    }

    let numberOfSuggestedDescription = 0;
    const lastExistingDescriptionsIndex = _.findLastIndex(SuggestedAssets.Descriptions, { Source: 'AdvExt_Description' });
    if (lastExistingDescriptionsIndex !== -1) {
      numberOfSuggestedDescription = SuggestedAssets.Descriptions.length - lastExistingDescriptionsIndex - 1;
    }

    let numberOfSuggestedHeadlineDescription;

    if (numberOfSuggestedHeadline >= 0 && numberOfSuggestedDescription >= 0) {
      if (numberOfSuggestedHeadline === 1 && numberOfSuggestedDescription === 1) {
        numberOfSuggestedHeadlineDescription
        = newI18n.getString(
            _TL_('Suggested additional {{numberOfSuggestedHeadline}} headline and {{numberOfSuggestedDescription}} description'),
            { numberOfSuggestedHeadline, numberOfSuggestedDescription }
          );
      } else if (numberOfSuggestedHeadline > 1 && numberOfSuggestedDescription === 1) {
        numberOfSuggestedHeadlineDescription
        = newI18n.getString(
            _TL_('Suggested additional {{numberOfSuggestedHeadline}} headlines and {{numberOfSuggestedDescription}} description'),
            { numberOfSuggestedHeadline, numberOfSuggestedDescription }
          );
      } else if (numberOfSuggestedHeadline === 1 && numberOfSuggestedDescription > 1) {
        numberOfSuggestedHeadlineDescription
        = newI18n.getString(
            _TL_('Suggested additional {{numberOfSuggestedHeadline}} headline and {{numberOfSuggestedDescription}} descriptions'),
            { numberOfSuggestedHeadline, numberOfSuggestedDescription }
          );
      } else if (numberOfSuggestedHeadline > 1 && numberOfSuggestedDescription > 1) {
        numberOfSuggestedHeadlineDescription
        = newI18n.getString(
            _TL_('Suggested additional {{numberOfSuggestedHeadline}} headlines and {{numberOfSuggestedDescription}} descriptions'),
            { numberOfSuggestedHeadline, numberOfSuggestedDescription }
          );
      } else if (numberOfSuggestedHeadline === 1 && numberOfSuggestedDescription === 0) {
        numberOfSuggestedHeadlineDescription
        = newI18n.getString(
            _TL_('Suggested additional {{numberOfSuggestedHeadline}} headline'),
            { numberOfSuggestedHeadline }
          );
      } else if (numberOfSuggestedHeadline > 1 && numberOfSuggestedDescription === 0) {
        numberOfSuggestedHeadlineDescription
        = newI18n.getString(
            _TL_('Suggested additional {{numberOfSuggestedHeadline}} headlines'),
            { numberOfSuggestedHeadline }
          );
      } else if (numberOfSuggestedHeadline === 0 && numberOfSuggestedDescription === 1) {
        numberOfSuggestedHeadlineDescription
        = newI18n.getString(
            _TL_('Suggested additional {{numberOfSuggestedDescription}} description'),
            { numberOfSuggestedDescription }
          );
      } else if (numberOfSuggestedHeadline === 0 && numberOfSuggestedDescription > 1) {
        numberOfSuggestedHeadlineDescription
        = newI18n.getString(
            _TL_('Suggested additional {{numberOfSuggestedDescription}} descriptions'),
            { numberOfSuggestedDescription }
          );
      }
    }

    return template({
      i18n: this.i18n,
      ad,
      moreHeadlines,
      moreDescriptions,
      numberOfSuggestedHeadlineDescription,
    });
  }

  get property() {
    return {
      get: item => _.first(item.Opportunities),
    };
  }
}
